import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <div className="min-h-screen bg-white font-sans">
        <header className="bg-white shadow-sm">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16 items-center">
              <div className="flex-shrink-0 flex items-center">
                <span className="text-2xl font-bold text-gray-900">Bare</span>
              </div>
              <div className="hidden sm:ml-6 sm:flex sm:items-center sm:space-x-8">
                <a href="#features" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
                  Features
                </a>
                <a href="#pricing" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
                  Pricing
                </a>
                <a href="#testimonials" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
                  Testimonials
                </a>
              </div>
              <div className="flex items-center space-x-4">
                {/* <a href="/user/sign_in" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
                  Sign In
                </a> */}
                <a
                  href="/user/sign_up"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700"
                >
                  Join the waitlist
                </a>
              </div>
            </div>
          </div>
        </header>

        <main>{children}</main>

        {/* <footer className="bg-gray-50">
          <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-500 tracking-wider uppercase">Company</h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <a href="#about" className="text-base text-gray-600 hover:text-gray-900">
                      About
                    </a>
                  </li>
                  <li>
                    <a href="#careers" className="text-base text-gray-600 hover:text-gray-900">
                      Careers
                    </a>
                  </li>
                  <li>
                    <a href="#blog" className="text-base text-gray-600 hover:text-gray-900">
                      Blog
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-500 tracking-wider uppercase">Support</h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <a href="#help" className="text-base text-gray-600 hover:text-gray-900">
                      Help Center
                    </a>
                  </li>
                  <li>
                    <a href="#contact" className="text-base text-gray-600 hover:text-gray-900">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-500 tracking-wider uppercase">Legal</h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <a href="#privacy" className="text-base text-gray-600 hover:text-gray-900">
                      Privacy
                    </a>
                  </li>
                  <li>
                    <a href="#terms" className="text-base text-gray-600 hover:text-gray-900">
                      Terms
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-500 tracking-wider uppercase">Connect</h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <a href="#twitter" className="text-base text-gray-600 hover:text-gray-900">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a href="#linkedin" className="text-base text-gray-600 hover:text-gray-900">
                      LinkedIn
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-8 border-t border-gray-200 pt-8">
              <p className="text-base text-gray-500 text-center">&copy; {new Date().getFullYear()} ayrpay. All rights reserved.</p>
            </div>
          </div>
        </footer> */}
      </div>
    </>
  );
}
